import { render, staticRenderFns } from "./FormPictograms.vue?vue&type=template&id=213cf7f8&scoped=true"
import script from "./FormPictograms.vue?vue&type=script&lang=js"
export * from "./FormPictograms.vue?vue&type=script&lang=js"
import style0 from "./FormPictograms.vue?vue&type=style&index=0&id=213cf7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213cf7f8",
  null
  
)

export default component.exports